import React, { FC } from 'react'
import { MarketableDetails } from '../../../modules/marketable-details'
import { LoadingSummary } from '../../../modules/marketable-details/summary/loading'
import { NoPageComponent } from '../../../modules/page-content/no-page.ui'
import { Router } from '../../../../router'
import { useMeal } from './hook'

export const MealSlug: FC = () => {
  const { loading, data } = useMeal()

  if (loading) return <LoadingSummary />
  if (!data) return <NoPageComponent onButtonClick={() => Router.back()} />

  return <MarketableDetails item={data.mealBySlug} />
}
